import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import { CheckBoxExample } from '../../components/examples/controls-examples';
export const _frontmatter = {
  "Title": "Checkbox"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "checkbox"
    }}>{`Checkbox`}</h1>
    <CheckBoxExample mdxType="CheckBoxExample" />
    <p>{`A Checkbox is a simple control that will cause a param to toggle from true to false.
It doesn't need anything else besides the common props.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Model
  showTimer={false}
  initialParams={{ checked: false }}
  controls={{
    type: 'checkbox',
    label: 'Check me',
    param: 'checked',
  }}
/>
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      